import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-admin-home',
    templateUrl: './admin-home.component.html',
    styleUrls: ['./admin-home.component.css'],
    standalone: false
})
export class AdminHomeComponent {}
